import { Box, IconButton, ListItem, ListItemText } from "@mui/material";
// @mui
import { styled } from "@mui/material/styles";
import isString from "lodash/isString";
import { useDropzone } from "react-dropzone";
import { fData } from "src/utils/formatNumber";

import Iconify from "../Iconify";
//
import Image from "../Image";
import BlockContent from "./BlockContent";
import RejectionFiles from "./RejectionFiles";
// type
import { UploadProps } from "./type";

// ----------------------------------------------------------------------

const DropZoneStyle = styled("div")(({ theme }) => ({
	outline: "none",
	overflow: "hidden",
	position: "relative",
	padding: theme.spacing(5, 1),
	borderRadius: theme.shape.borderRadius,
	transition: theme.transitions.create("padding"),
	backgroundColor: theme.palette.background.neutral,
	border: `1px dashed ${theme.palette.grey[500_32]}`,
	"&:hover": { opacity: 0.72, cursor: "pointer" }
}));

// ----------------------------------------------------------------------

export default function UploadSingleFile({
	error = false,
	file,
	helperText,
	sx,
	onRemove,
	...other
}: UploadProps) {
	const { getRootProps, getInputProps, isDragActive, isDragReject, fileRejections } = useDropzone({
		multiple: false,
		...other
	});

	const name: string = file && isString(file.name) ? file.name : "File";

	return (
		<Box sx={{ width: "100%", ...sx }}>
			<DropZoneStyle
				{...getRootProps()}
				sx={{
					...(isDragActive && { opacity: 0.72 }),
					...((isDragReject || error) && {
						color: "error.main",
						borderColor: "error.light",
						bgcolor: "error.lighter"
					}),
					...(file && {
						padding: "6% 0"
					})
				}}
			>
				<input {...getInputProps()} />

				<BlockContent />

				{file && (
					<Image
						alt='file preview'
						src={isString(file) ? file : file.preview}
						sx={{
							top: 8,
							left: 8,
							borderRadius: 1,
							position: "absolute",
							width: "calc(100% - 16px)",
							height: "calc(100% - 16px)"
						}}
					/>
				)}
			</DropZoneStyle>

			{fileRejections.length > 0 && <RejectionFiles fileRejections={fileRejections} />}

			{file && (
				<ListItem
					sx={{
						my: 1,
						px: 2,
						py: 0.75,
						borderRadius: 0.75,
						border: (theme) => `solid 1px ${theme.palette.divider}`
					}}
				>
					<Iconify
						icon={"eva:file-fill"}
						sx={{ width: 28, height: 28, color: "text.secondary", mr: 2 }}
					/>

					<ListItemText
						primary={name}
						primaryTypographyProps={{ variant: "subtitle2" }}
						secondary={isString(file) ? "" : fData(file.size || 0)}
						secondaryTypographyProps={{ variant: "caption" }}
					/>

					<IconButton edge='end' onClick={() => onRemove && onRemove()} size='small'>
						<Iconify icon={"eva:close-fill"} />
					</IconButton>
				</ListItem>
			)}

			{helperText && helperText}
		</Box>
	);
}
